import React from 'react';
import { Info } from 'lucide-react';

const FieldInfo = ({ description }) => {
 return (
 <span className="inline-block ml-1 group relative">
 <Info className="w-3 h-3 text-blue-500 cursor-help" />
 <span className="invisible group-hover:visible absolute left-0 top-5 w-64 bg-slate-800 text-white text-xs p-2 rounded shadow-lg z-10">
 {description}
 </span>
 </span>
 );
};

export default FieldInfo;
